/**
 * Returns the root domain of the host, aka domain without subdomain.
 * E.g. Input 'fizz.buzz.olb.de' will return 'olb.de'.
 * For more info visit: https://moz.com/learn/seo/domain
 * @param hostname Hostname to be formatted
 * @returns the formatted hostname
 */
export function getRootDomain(hostname: string) {
	const parts = hostname.split('.').reverse();
	return `${parts[1]}.${parts[0]}`;
}
